<section class="head">
  <div class="innerMain">
    <div class="logoHolder">
      <picture>
        <source media="(min-width: 800px)" srcset="assets/images/dart-spielen-kassel-lohfelden-header.webp" type="image/webp">
        <img
          src="assets/images/mobile.webp"
          alt="Dart Rock Café Lohfelden bei Kassel"
          fetchpriority="high"
          decoding="async"
          class="hero-bg"
          width="800"
          height="600"
        >
      </picture>
      <div class="logo">
        <img
          src="assets/images/DRC-Logo-white.svg"
          alt="Dart Rock Cafe Lohfelden"
          id="logo"
          fetchpriority="high"
          decoding="async"
          width="300"
          height="146"
        >
        <div>
          Hier findest du uns:<br>
          <span>Hauptstrasse 46, 34253 Lohfelden</span>
          <a class="button" [routerLink]="['dart-spielen-kassel']" [attr.href]="'dart-spielen-kassel'">
            <div class="ping">
              <div class="ping-dot"></div>
              <div class="ping-ring"></div>
            </div>
            Dart spielen in Kassel</a>
        </div>
      </div>
    </div>
    <div class="opening">
      <div class="heading3">
        Unsere Öffnungszeiten
      </div>
      <div class="split">
        <div class="element">
          <div>Dienstag - Donnerstag</div>
          <div>17:00 - 23:00</div>
        </div>
        <div class="element">
          <div>Freitag und Samstag</div>
          <div>17:00 - 01:00</div>
        </div>
      </div>
    </div>
  </div>
  <div class="moreInformation">
    <div class="inner">
      <img src="assets/images/arrow-down.svg" alt="Für mehr Informationen runter scrollen">
      <svg viewBox="0 0 200 200" width="130" height="130" class="rotate">
        <defs>
          <path id="kreis" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0"></path>
        </defs>
        <text font-size="18" font-family="system-ui, sans-serif" fill="#111" letter-spacing="1">
          <textPath href="#kreis" startOffset="0">
            <tspan dy="-4">MEHR · INFORMATIONEN · MEHR · INFORMATIONEN</tspan>
          </textPath>
        </text>
      </svg>
    </div>
  </div>

</section>
